import styled from 'styled-components';

type ArticlesWrapperProps = {
  numberOfColumns: number;
};


export const CarouselItemWrapper = styled.div`
  text-align: left;

  [class*='Articlestyles__ArticleWrapper'] {
    height: 100%;
    a {
      height: 100%;
    }
  }
`;

export const CtaButtonWrapper = styled.div`
  margin-top: 34px;
  button {
    margin: 0;
  }
`;

export const SeeAllMediaButton = styled.a`
  display: flex;
  align-items: flex-start;
  align-self: flex-end;
  color: #E60000;
  cursor: pointer;
  text-decoration: none;

  [class*='Iconstyle__Icon-sc'] {
    margin-top: 3px;

    @media (max-width: 757px) {
      margin-top: 0;
    }
  }
    
  &:hover  {
    color: #E60000 !important;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;


export const ArticlesWrapper = styled.div<ArticlesWrapperProps>`
  display: grid;
  --columns: ${({ numberOfColumns }) => numberOfColumns};
  grid-template-columns: repeat(var(--columns), minmax(auto, 1fr));
  align-items: stretch;
  gap: 28px;

  div.featured-article-grid {
    grid-column: 1/-1;
  }

  @media (max-width: 1150px) {
    --columns: 1;
  }
`;

export const IconsAndTextCardsWrapper = styled.div<ArticlesWrapperProps>`
  display: grid;
  --columns: ${({ numberOfColumns }) => numberOfColumns};
  grid-template-columns: repeat(var(--columns), minmax(auto, 1fr));
  align-items: stretch;
  gap: 20px;

  @media (max-width: 640px) {
    --columns: 1;
  }
`;

export const CardsWrapper = styled.div<ArticlesWrapperProps>`
  display: grid;
  width: 100%;
  --columns: ${({ numberOfColumns }) => numberOfColumns};
  grid-template-columns: repeat(var(--columns), minmax(auto, 1fr));
  align-items: stretch;
  gap: 20px;

  @media (max-width: 640px) {
    --columns: 1;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 32px;
  flex-direction: column;
  padding: 1em 0 2em 0;

`;

export const CarouselWrapper = styled.div`
  [class*='CarouselArrowstyle__CarouselArrow-sc'] {
    display: none;
  }

  .slick-slide {
    margin: 0 10px;
    padding: 1em 0 1em 0;
  }
`;
